module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control margin-bottom",
    attrs: {
      "type": "radio",
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "maxlength": _vm.item.maxlength
    },
    domProps: {
      "value": _vm.item.value
    },
    on: {
      "input": _vm.update
    }
  }), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a6d4ce"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-components/emt-radio.vue
// module id = 97
// module chunks = 0